import React, { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages } from "react-intl";

import globalMessages from "../../intl/globalMessages";

const messages = defineMessages({
  ...globalMessages,
  reservationId: {
    id: "app.swalTestEmailForm.reservationId",
    description: "Placeholder for reservationID input",
    defaultMessage: "Reservation ID",
  },
  destinationEmail: {
    id: "app.swalTestEmailForm.destinationEmail",
    description: "Placeholder for emails input",
    defaultMessage: "Destination emails",
  },
});

class SwalTestEmailForm extends Component {
  state = {
    destinationEmail: this.props.destinationEmail,
    reservationId: this.props.reservationId,
  };

  changeEmail(e) {
    let destinationEmail = e.target.value;
    const formValues = {
      ...this.state,
      destinationEmail,
    };
    this.setState(formValues);
    this.props.onChange({ formValues });
  }

  changeReservationId(e) {
    let reservationId = e.target.value;
    const formValues = {
      ...this.state,
      reservationId,
    };
    this.setState(formValues);
    this.props.onChange({ formValues });
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}>
        <input
          style={{
            padding: 5,
          }}
          placeholder={this.props.intl.formatMessage(messages.destinationEmail)}
          value={this.state.destinationEmail}
          onChange={this.changeEmail.bind(this)}
        />
        <input
          style={{
            padding: 5,
          }}
          placeholder={this.props.intl.formatMessage(messages.reservationId)}
          value={this.state.reservationId}
          onChange={this.changeReservationId.bind(this)}
        />
      </div>
    );
  }
}

SwalTestEmailForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  destinationEmail: PropTypes.string,
  reservationId: PropTypes.string,
};

export default SwalTestEmailForm;
